import React, { useState, useContext } from "react";

import { ICommentApiResponse } from "../../lib/models/IComment";

import { CommentsContext } from "./CommentsContext";
import { submitComment } from "../../lib/api/commentsApi";

interface IProps {
  heading: string;
  notes: string;
  showHeading: boolean;
  isAuthenticated: boolean;
  pageId: string;
}

const CommentsBox = (props: IProps) => {
  const { addComment } = useContext(CommentsContext);
  const [commentBody, setCommentbody] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [response, setResponse]: [
    ICommentApiResponse,
    React.Dispatch<ICommentApiResponse>
  ] = useState(null);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!submitting) {
      setSubmitting(true);
      submitComment(props.pageId, commentBody)
        .then((e) => e.json())
        .then((e) => {
          setSubmitting(false);
          if (e.errors !== null) {
            return setResponse(e);
          }
          setCommentbody("");
          addComment(e.data);
          setResponse(null);
        });
    }
  };

  if (!props.isAuthenticated) {
    return (
      <div className="comments__box__notes">
        <p>Please log in to leave a comment</p>
      </div>
    );
  }
  return (
    <div className="comments__box">
      <h2 className="comments__box__heading">
        {props.heading || "Leave a Comment"}
      </h2>
      {props.notes && (
        <div className="comments__box__notes">
          <p>{props.notes}</p>
        </div>
      )}
      <div className="EPiServerForms">
        <form onSubmit={handleSubmit}>
          <div className="Form__Element">
            <label htmlFor="Body" className="Form__Element__Caption">
              Your message *
            </label>
            <textarea
              id="Body"
              name="Body"
              maxLength={280}
              value={commentBody}
              onChange={(e) => setCommentbody(e.currentTarget.value)}
            />
          </div>
          <button className="btn-primary" type="submit" disabled={submitting}>
            {submitting ? "Submitting Comment" : "Post Comment"}
          </button>
        </form>
      </div>
      <span className="comments__box__errors">
        {/* Error Messages */}
        {response?.errors?.map((e, i) => (
          <div
            key={i}
            className="comments__box__notes comments__box__notes--error"
          >
            <p>{e}</p>
          </div>
        ))}
      </span>
    </div>
  );
};

export default CommentsBox;
